 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","inspect":"inspect","pf":"pf","ApproachPf-v2":"ApproachPf-v2","BankingRalationships-v2":"BankingRalationships-v2","BusinessRisk-v2":"BusinessRisk-v2","ExecutiveSummary-v2":"ExecutiveSummary-v2","FinancialRisk-v2":"FinancialRisk-v2","PoliticsPf-v2":"PoliticsPf-v2","generalData-v2":"generalData-v2","pf-loader":"pf-loader","pf-modal":"pf-modal"}[chunkId]||chunkId) + "." + {"about":"48c87bb4","chunk-0a3fa479":"aceb78ec","chunk-19cb1ef0":"ecc02cfe","chunk-213b7407":"ffc46eee","chunk-2951edf2":"644a356e","chunk-2d0bd966":"b4996319","chunk-2d207ee7":"06aa2bf4","chunk-2ebc100b":"6907b848","chunk-34cb1632":"74157fc3","chunk-37afa293":"06ca307b","chunk-7693d05c":"c53c0bf4","chunk-79757ecc":"e3a3194f","chunk-c1461c34":"dbbd6a74","chunk-da7b32a0":"acce62a4","chunk-e7746528":"7c973d5a","inspect":"56a37fb1","pf":"6ba7a666","chunk-087b55cd":"691f82d0","chunk-2d228e53":"2600dee0","chunk-44ca2cee":"e5193da1","chunk-4bf9c421":"24cd6177","chunk-b9d10726":"09b8ba4f","chunk-bc183a76":"7c4637e7","chunk-dfd24750":"f74ed917","chunk-fb76f4d0":"e3133176","chunk-059e5780":"4a8dedd8","chunk-593c1fcb":"a94c32cf","chunk-ebda0760":"c9c6cdcc","ApproachPf-v2":"afde4486","BankingRalationships-v2":"7e94210d","BusinessRisk-v2":"769a0422","ExecutiveSummary-v2":"593cfbfa","chunk-22ece66a":"6072ae73","FinancialRisk-v2":"0ab17d4d","PoliticsPf-v2":"64a671f7","chunk-2d0c7f30":"4ed55662","generalData-v2":"769c4896","pf-loader":"c8749ea4","pf-modal":"08e4db2e","chunk-0040b3fa":"24614b9e","chunk-1da165d2":"b7c97968","chunk-201c9986":"ff002878","chunk-3dac60bf":"1d89b7bf","chunk-45a28774":"e2ab2723","chunk-54bfe014":"71dde211","chunk-5578bfa8":"8416ee57","chunk-6d62354d":"b800c40f","chunk-8a505996":"409f3e3d","chunk-11a0d341":"0cdab548","chunk-3498f38f":"031d4d2f","chunk-37992326":"6d29d293","chunk-66c2e41d":"49d178b1","chunk-7c1d807f":"35da5e8f","chunk-e349d29a":"18a2a2d6","chunk-d260ff64":"ced23d19"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"chunk-0a3fa479":1,"chunk-7693d05c":1,"chunk-da7b32a0":1,"chunk-e7746528":1,"pf":1,"chunk-087b55cd":1,"chunk-bc183a76":1,"chunk-fb76f4d0":1,"chunk-059e5780":1,"chunk-593c1fcb":1,"chunk-ebda0760":1,"FinancialRisk-v2":1,"chunk-3dac60bf":1,"chunk-5578bfa8":1,"chunk-3498f38f":1,"chunk-d260ff64":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","inspect":"inspect","pf":"pf","ApproachPf-v2":"ApproachPf-v2","BankingRalationships-v2":"BankingRalationships-v2","BusinessRisk-v2":"BusinessRisk-v2","ExecutiveSummary-v2":"ExecutiveSummary-v2","FinancialRisk-v2":"FinancialRisk-v2","PoliticsPf-v2":"PoliticsPf-v2","generalData-v2":"generalData-v2","pf-loader":"pf-loader","pf-modal":"pf-modal"}[chunkId]||chunkId) + "." + {"about":"a1d83074","chunk-0a3fa479":"f4eae6e9","chunk-19cb1ef0":"31d6cfe0","chunk-213b7407":"31d6cfe0","chunk-2951edf2":"31d6cfe0","chunk-2d0bd966":"31d6cfe0","chunk-2d207ee7":"31d6cfe0","chunk-2ebc100b":"31d6cfe0","chunk-34cb1632":"31d6cfe0","chunk-37afa293":"31d6cfe0","chunk-7693d05c":"cb33ff60","chunk-79757ecc":"31d6cfe0","chunk-c1461c34":"31d6cfe0","chunk-da7b32a0":"187b5f99","chunk-e7746528":"107b9bc0","inspect":"31d6cfe0","pf":"273b6abe","chunk-087b55cd":"2532cdc0","chunk-2d228e53":"31d6cfe0","chunk-44ca2cee":"31d6cfe0","chunk-4bf9c421":"31d6cfe0","chunk-b9d10726":"31d6cfe0","chunk-bc183a76":"07f31648","chunk-dfd24750":"31d6cfe0","chunk-fb76f4d0":"35321c95","chunk-059e5780":"41d331b1","chunk-593c1fcb":"13f47d14","chunk-ebda0760":"0e85e8b1","ApproachPf-v2":"31d6cfe0","BankingRalationships-v2":"31d6cfe0","BusinessRisk-v2":"31d6cfe0","ExecutiveSummary-v2":"31d6cfe0","chunk-22ece66a":"31d6cfe0","FinancialRisk-v2":"555a1c14","PoliticsPf-v2":"31d6cfe0","chunk-2d0c7f30":"31d6cfe0","generalData-v2":"31d6cfe0","pf-loader":"31d6cfe0","pf-modal":"31d6cfe0","chunk-0040b3fa":"31d6cfe0","chunk-1da165d2":"31d6cfe0","chunk-201c9986":"31d6cfe0","chunk-3dac60bf":"bd59fd05","chunk-45a28774":"31d6cfe0","chunk-54bfe014":"31d6cfe0","chunk-5578bfa8":"9da7a836","chunk-6d62354d":"31d6cfe0","chunk-8a505996":"31d6cfe0","chunk-11a0d341":"31d6cfe0","chunk-3498f38f":"3a0ebf42","chunk-37992326":"31d6cfe0","chunk-66c2e41d":"31d6cfe0","chunk-7c1d807f":"31d6cfe0","chunk-e349d29a":"31d6cfe0","chunk-d260ff64":"13f47d14"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
